<div class="cf-frontend-sdk-cplace-control-label-container" [class.grouped]="grouped">
  <span *ngIf="required" class="cf-frontend-sdk-cplace-control-label-required">*</span>
  <span *ngIf="readonly" class="cf-frontend-sdk-cplace-control-label-readonly"><i class="hui hui-pencil-slash"></i></span>
  <label [for]="labelFor">{{ label }}</label>
  <cf-frontend-sdk-alert-icon *ngIf="alert" [severity]="'info'" tooltipPosition="top" [pTooltip]="alert"></cf-frontend-sdk-alert-icon>
</div>
<div class="cf-frontend-sdk-cplace-control-content-and-feedback-message-container">
  <div class="cf-frontend-sdk-cplace-control-content-and-action-buttons-container">
    <div class="cf-frontend-sdk-cplace-control-content-and-feedback-message-container">
      <!--Warning: this element's data attributes are used in typescript-->
      <div
        class="cf-frontend-sdk-cplace-control-content"
        data-element-name="control-content"
        [attr.data-component-id]="componentId"
        [class.submit-success]="submitSuccess"
        [class.edit-mode]="editMode"
        [class.grouped]="grouped"
        [ngClass]="validationSeverity"
      >
        <ng-content></ng-content>
      </div>
      <div class="cf-frontend-sdk-cplace-control-feedback-message" [ngClass]="validationSeverity" *ngIf="validationMessage">
        {{ validationMessage }}
      </div>
    </div>
    <div class="cf-frontend-sdk-cplace-control-action-buttons" [attr.not-visible]="!editMode || readonly || disabled">
      <div class="cf-frontend-sdk-cplace-control-spinner-container" [class.submitting]="submitting">
        <p-progressSpinner
          strokeWidth="6"
          styleClass="cf-frontend-sdk-cplace-control-spinner"
          [style]="{ width: '1rem', height: '1rem' }"
        ></p-progressSpinner>
      </div>
      <!--Warning: this element's data attributes are used in typescript-->
      <button
        pButton
        class="cf-frontend-sdk-cplace-control-skeleton-cancel-button p-button-icon-only p-button-text"
        icon="fa fa-undo"
        tooltipPosition="top"
        data-element-name="cancel-button"
        [attr.data-component-id]="componentId"
        [class.submitting]="submitting"
        [attr.aria-label]="'cf-frontend-sdk.shared.cancel' | translate"
        [pTooltip]="'cf-frontend-sdk.shared.cancel' | translate"
        (click)="handleCancelButtonClick($event)"
      ></button>
    </div>
  </div>
</div>
